<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    variant = "primary",
    size = "md",
    type = "button",
    disabled = false,
    fullWidth = false,
    loading = false,
    class: className = "",
    onclick,
    children,
  }: {
    variant?: "primary" | "secondary" | "danger" | "ghost";
    size?: "sm" | "md" | "lg";
    type?: "button" | "submit";
    disabled?: boolean;
    fullWidth?: boolean;
    loading?: boolean;
    class?: string;
    onclick?: (e: MouseEvent) => void;
    children?: Snippet;
  } = $props();

  const variantClass: Record<string, string> = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    danger: "btn-danger",
    ghost: "btn-ghost",
  };

  const sizeClass: Record<string, string> = {
    sm: "btn-sm",
    md: "",
    lg: "btn-lg",
  };
</script>

<button
  {type}
  disabled={disabled || loading}
  class="btn {variantClass[variant]} {sizeClass[size]} {fullWidth ? 'btn-full' : ''} {className}"
  {onclick}
>
  {#if loading}
    <span class="btn-spinner" aria-hidden="true"></span>
  {/if}
  {#if children}
    {@render children()}
  {/if}
</button>

<style>
  .btn-sm {
    padding: 6px 12px;
    font-size: var(--font-size-sm, 14px);
    min-height: 36px;
  }
  .btn-lg {
    padding: 12px 24px;
    font-size: var(--font-size-md, 16px);
    min-height: 52px;
  }
  .btn-full {
    width: 100%;
  }
  .btn-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid color-mix(in srgb, currentColor 28%, transparent);
    border-top-color: currentColor;
    border-radius: 50%;
    margin-right: 8px;
    animation: spin 0.6s linear infinite;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>
